import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Api } from './api';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports:   [ CommonModule,
               HttpClientModule ],
  providers: [ Api ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/core/core.module.ts